import React from "react";
import { useState } from "react";

const Form = ({
    formData,
    setFormData,
    handleSubmit,
    setShowForm,
    newUserAdded,
    setNewUserAdded
}) => {

    const [errors, setErrors] = useState({}); // Track validation errors

    // Validation function
    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.name.trim()) {
            newErrors.name = "First Name is required";
        }

        if (!formData.email.trim()) {
            newErrors.email = "Email Address is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Please enter a valid email address";
        }

        if (!formData.linkedinURL.trim()) {
            newErrors.linkedinURL = "LinkedIn URL is required";
        } else if (!/^https:\/\/(www\.)?linkedin\.com\/in\/.+$/.test(formData.linkedinURL)) {
            newErrors.linkedinURL = "Please enter a valid LinkedIn profile URL";
        }

        if (!formData.achievement.trim()) {
            newErrors.achievement = "This field is required";
        }

        if (!formData.expertise.trim()) {
            newErrors.expertise = "This field is required";
        }

        if (!formData.support.trim()) {
            newErrors.support = "This field is required";
        }

        // if (!formData.emailConsent) {
        //     newErrors.emailConsent = "You must agree to the email consent";
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Returns true if no errors
    };

    // Handle form submission
    const onSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            handleSubmit(); // Call parent submission handler
            setShowForm(true);
        }
        
    };
    
    return (
        <>
        <div id="form-section" className="bg-gradient-to-b  rounded-lg shadow">
            <div className="p-6">
                <div className="text-center mb-8">
                <h1 className="text-3xl font-cormorant text-green-800 mb-4">🎄 Nonprofit Community Garland 🎄</h1>
                <p className="text-green-700">
                    Share your expertise and find the support you need for the year ahead!
                </p>
            </div>

            {newUserAdded &&
                <div className="mb-6 bg-white p-4 rounded-lg shadow-sm">
                    <h2 className="text-2xl font-cormorant text-green-800 text-center mb-6">
                        🌟 Thank You For Adding to the Community Garland 🌟
                    </h2>
                    {/* <button 
                        onClick={() => setNewUserAdded(false)}
                        type="submit"
                        className="w-full bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded font-medium transition-colors"
                    >
                        or Add Another User
                    </button> */}
                </div> 
            }

            {!newUserAdded &&
            <form onSubmit={onSubmit} className="space-y-4 bg-white p-6 rounded-lg shadow-sm">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input
                        placeholder="First Name"
                        value={formData.name}
                        onChange={(e) => setFormData({...formData, name: e.target.value})}
                        required
                        className="w-full p-2 border border-green-200 rounded"
                    />
                    {errors.name && <p className="text-red-500 text-sm validation-text">{errors.name}</p>}

                    <input
                        type="email"
                        placeholder="Email Address"
                        value={formData.email}
                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                        required
                        className="w-full p-2 border border-green-200 rounded email"
                    />
                    {errors.email && <p className="text-red-500 text-sm validation-text">{errors.email}</p>}

                </div>
                
                <div>
                    <input
                    placeholder="LinkedIn URL (https://www.linkedin.com/in/...)"
                    value={formData.linkedinURL}
                    onChange={(e) => setFormData({...formData, linkedinURL: e.target.value})}
                    required
                    className="w-full p-2 border border-green-200 rounded linkedin"
                    />
                    {errors.linkedinURL && <p className="text-red-500 text-sm validation-text">{errors.linkedinURL}</p>}
                </div>

                <input
                    placeholder="What achievement are you grateful for this year?"
                    value={formData.achievement}
                    onChange={(e) => setFormData({...formData, achievement: e.target.value})}
                    required
                    className="w-full p-2 border border-green-200 rounded"
                />
                {errors.achievement && <p className="text-red-500 text-sm validation-text">{errors.achievement}</p>}

                <input
                    placeholder="What expertise can you share? (e.g., grant writing, volunteer management)"
                    value={formData.expertise}
                    onChange={(e) => setFormData({...formData, expertise: e.target.value})}
                    required
                    className="w-full p-2 border border-green-200 rounded"
                />
                {errors.expertise && <p className="text-red-500 text-sm validation-text">{errors.expertise}</p>}

                <input
                    placeholder="What support are you seeking? (e.g., marketing strategy, fundraising tips)"
                    value={formData.support}
                    onChange={(e) => setFormData({...formData, support: e.target.value})}
                    required
                    className="w-full p-2 border border-green-200 rounded"
                />
                {errors.support && <p className="text-red-500 text-sm validation-text">{errors.support}</p>}

                <div className="flex items-start gap-2">
                    <input
                        type="checkbox"
                        id="emailConsent"
                        checked={formData.emailConsent}
                        onChange={(e) => setFormData({...formData, emailConsent: e.target.checked})}
                        className="mt-1"
                    />
                    <label htmlFor="emailConsent" className="text-sm text-gray-600">
                    I agree to be added to Positive Equation's email list to receive information about potential matches and community updates.
                    </label>
                </div>
                {errors.emailConsent && <p className="text-red-500 text-sm validation-text">{errors.emailConsent}</p>}

                <button 
                //    onClick={() => setShowForm(true)}
                    type="submit"
                    className="w-full bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded font-medium transition-colors"
                >
                    Add to Garland 
                </button>
            </form>
            }
            </div>
        </div>
        {/* <button 
            onClick={() => setShowForm(true)}
            className="mx-auto block bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded font-medium transition-colors"
        >
            Add Your Submission
        </button> */}
        </>
    );
}

export default Form;